import toast from "react-hot-toast";
import { put, takeEvery } from "redux-saga/effects";
import { loginServ, signUpServ, verifyUserServ } from "../services/auth.service";
import { authActions } from '../slice/auth.slice';
import { USER_LOGIN, USER_LOGOUT, USER_SIGN_UP, USER_VERIFY } from "../types/auth.types";
import { GENERAL_ERROR } from "static/static";

export function* loginSaga(action) {
    try {
        const user = yield loginServ(action.payload)
        if(user){
            yield put(authActions.actions.loginUserStatus(true))
        }
        else{
            toast.error("Failed to Authenticate")
        }
    } catch (err) {
        console.log("err", err);
        toast.error("Failed to Authenticate")
    }
}

export function* signUpSaga(action) {
    try {
        const user = yield signUpServ(action.payload)
        if (user) {
            yield put(authActions.actions.setCurrentUserSlice(user))
            yield put(authActions.actions.setSignUpTab(1))
        }
        else {
            toast.error("Failed to Authenticate")
        }
    } catch (err) {
        console.log("err", err?.response?.data?.detail);
        toast.error(err?.response?.data?.detail || GENERAL_ERROR);
    }
}


export function* verifyUserSaga(action) {
    try {
        const user = yield verifyUserServ(action.payload)
        if (user) {
            yield put(authActions.actions.loginUserStatus(true))
            yield put(authActions.actions.setSignUpTab(2))
        }
        else {
            toast.error("Failed to Authenticate")
        }
    } catch (err) {
        console.log("err", err);
        toast.error(err?.response?.data?.detail || GENERAL_ERROR);
    }
}

export function* logoutSaga() {
    try {
        localStorage.clear();
        yield put(authActions.actions.resetAuth());
        yield put(authActions.actions.loginUserStatus(false));
    } catch (err) {
        console.log("err", err);
        toast.error(err?.response?.data?.message || GENERAL_ERROR);
    }
}

export function* watchAuthAsync() {
    yield takeEvery(USER_LOGIN, loginSaga);
    yield takeEvery(USER_LOGOUT, logoutSaga);
    yield takeEvery(USER_SIGN_UP, signUpSaga);
    yield takeEvery(USER_VERIFY, verifyUserSaga);
}